/* Official Affirm messaging only. No local loan calculations or checkout redirect. */
(function () {
  'use strict';
  var config = window.MaytrixAffirmConfig;
  if (!config || window.MaytrixAffirm || window.self !== window.top || config.currency !== 'USD') return;
  var preview = new URLSearchParams(location.search).get('myx_affirm_preview') === '1';
  if (!config.enabled && !config.reviewEnabled && !preview) return;
  // App blocks own ordinary product pages; only attach our dynamic quote on review.
  var reviewOnly = !config.enabled && !preview;
  var selector = reviewOnly ? '[data-myx-affirm-message]:not([data-myx-affirm-product])' : '[data-myx-affirm-message]';
  var started = false, refreshTimer, observer;
  function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      if (window.affirm?.ui?.refresh) window.affirm.ui.refresh();
    }, 120);
  }
  function load() {
    if (started) return;
    started = true;
    document.documentElement.classList.add('myx-affirm-enabled');
    if (!window.affirm?.ui) {
      window._affirm_config = {public_api_key: config.publicKey, script: 'https://cdn1.affirm.com/js/v2/affirm.js'};
      // Affirm's official asynchronous loader, as supplied in its Shopify guide.
      (function(l,g,m,e,a,f,b){var d,c=l[m]||{},h=document.createElement(f),n=document.getElementsByTagName(f)[0],k=function(a,b,c){return function(){a[b]._.push([c,arguments])}};c[e]=k(c,e,'set');d=c[e];c[a]={};c[a]._=[];d._=[];c[a][b]=k(c,a,b);a=0;for(b='set add save post open empty reset on off trigger ready setProduct'.split(' ');a<b.length;a++)d[b[a]]=k(c,e,b[a]);a=0;for(b=['get','token','url','items'];a<b.length;a++)d[b[a]]=function(){};h.async=!0;h.src=g[f];n.parentNode.insertBefore(h,n);delete g[f];d(g);l[m]=c})(window,window._affirm_config,'affirm','checkout','ui','script','ready');
    }
    window.affirm.ui.ready(refresh);
  }
  function setAmount(node, amount) {
    if (!node) return;
    var cents = Number(amount);
    if (!Number.isSafeInteger(cents) || cents <= 0) {
      node.hidden = true;
      node.classList.remove('affirm-as-low-as');
      node.removeAttribute('data-amount');
      node.replaceChildren();
      return;
    }
    var changed = node.getAttribute('data-amount') !== String(cents) || !node.classList.contains('affirm-as-low-as');
    node.setAttribute('data-amount', String(cents));
    node.classList.add('affirm-as-low-as');
    node.hidden = false;
    if (observer) observer.observe(node); else load();
    if (changed && started) refresh();
  }
  function scan(root) {
    if (root.matches?.(selector)) setAmount(root, root.getAttribute('data-amount'));
    root.querySelectorAll?.(selector).forEach(function (node) { setAmount(node, node.getAttribute('data-amount')); });
  }
  window.MaytrixAffirm = Object.freeze({setAmount: setAmount, refresh: refresh});
  if ('IntersectionObserver' in window) {
    observer = new IntersectionObserver(function (entries) {
      if (entries.some(function (entry) { return entry.isIntersecting; })) load();
    }, {rootMargin: '250px'});
  }
  scan(document);
  // Streamline dispatches this event on the owning product container, before
  // its hidden variant selector changes. Capture also covers unavailable variants.
  document.addEventListener('variantChange', function (event) {
    if (reviewOnly) return;
    var variant = event.detail?.variant;
    event.target.querySelectorAll?.('[data-myx-affirm-product]').forEach(function (node) {
      setAmount(node, variant && variant.price);
    });
  }, true);
  // Quick-shop panels and the 3D review are inserted after load.
  new MutationObserver(function (changes) {
    changes.forEach(function (change) {
      change.addedNodes.forEach(function (node) {
        if (node.nodeType === 1 && !node.closest('.affirm-as-low-as')) scan(node);
      });
    });
  }).observe(document.body, {childList: true, subtree: true});
})();
